const viewports = {
  xs: "321",
  sm: "600",
  // screen-sm-min
  md: "768",
  // screen-md-min
  lg: "970" // screen-lg-min
};
module.exports = viewports;